import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

const APIDocsCreateCategoryBlock = () => {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Create category</div>
        <div className="text">Creates a new category.</div>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description: "The id of the board you'd like to create the category for.",
              heading: 'boardID',
              subheading: 'string',
            },
            {
              description: 'The name of the category. Must be between 1 and 30 characters long.',
              heading: 'name',
              subheading: 'string',
            },
            {
              description: 'The id of the parent category.',
              heading: 'parentID',
              subheading: 'string (optional)',
            },
            {
              description: 'Whether or not the admins will be subscribed to the category.',
              heading: 'subscribeAdmins',
              subheading: 'boolean',
            },
          ]}
        />
        <div className="subheading">Returns</div>
        <div className="text">Upon success, returns an object with a single key: id.</div>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v1/categories/create</Highlight>
        <APIDocsMethod />
        <APIDocsCurl
          path="https://canny.io/api/v1/categories/create"
          body={`\\
  -d apiKey=YOUR_API_KEY \\
  -d boardID=553c3ef8b8cdcd1501ba1234 \\
  -d name="new category" \\
  -d parentID=423c3ef8b8cdcd1501ba3763 \\
  -d subscribeAdmins=true
  `}
        />
        <div className="text">Example Response</div>
        <Highlight lang="json">
          {`{
  "id": "553c3ef8b8cdcd1501ba1240",
}`}
        </Highlight>
      </div>
    </APIDocsBlock>
  );
};

export default APIDocsCreateCategoryBlock;
